// src/helpers/settings/tableLayoutCreator.ts
var calculatePositionOfRotatedElement = (element, realXPosition, realYPosition) => {
  const angleInRadians = Math.abs(element.rotation) * (Math.PI / 180);
  const newBoundingBox = getWidthAndHeightOfRotatedElement(
    element,
    angleInRadians
  );
  let calculatedWidth = newBoundingBox.calculatedWidth;
  const { cx, cy } = {
    cx: realXPosition + element.width / 2,
    cy: realYPosition + element.height / 2
  };
  const x1 = realXPosition;
  const y1 = realYPosition;
  const y2 = cy + (x1 - cx) * Math.sin(angleInRadians) + (y1 - cy) * Math.cos(angleInRadians);
  calculatedWidth += newBoundingBox.widthDifference;
  return {
    calculatedWidth,
    calculatedHeight: newBoundingBox.calculatedHeight,
    calculatedLeftXPosition: realXPosition + newBoundingBox.widthDifference,
    calculatedYPosition: y2
  };
};
var getWidthAndHeightOfRotatedElement = (element, angleInRadians) => {
  const calculatedWidth = Math.floor(
    element.width * Math.cos(angleInRadians) + element.height * Math.sin(angleInRadians)
  );
  const calculatedHeight = Math.floor(
    element.width * Math.sin(angleInRadians) + element.height * Math.cos(angleInRadians)
  );
  const widthDifference = (element.width - calculatedWidth) / 2;
  const heightDifference = (element.height - calculatedHeight) / 2;
  return {
    calculatedWidth,
    calculatedHeight,
    widthDifference,
    heightDifference
  };
};
var getNewPositionWithRotationCore = (element, newRotation, state, validateRotationZero = false) => {
  const { gridWidth, gridHeight, smallUnitSize } = state.tableLayout.toolSettings;
  const newAngleInRadians = Math.abs(newRotation) * (Math.PI / 180);
  if (newAngleInRadians !== 0 || element.rotation !== 0 || validateRotationZero) {
    const calculatedValues = getWidthAndHeightOfRotatedElement(
      element,
      newAngleInRadians
    );
    const newWidth = element.width - calculatedValues.widthDifference;
    const newHeight = calculatedValues.calculatedHeight - Math.abs(calculatedValues.heightDifference);
    const spaceLeftX = element.xCoordinate + calculatedValues.widthDifference;
    const spaceRightX = gridWidth - element.xCoordinate - newWidth;
    const spaceLeftTopY = element.yCoordinate + calculatedValues.heightDifference;
    const spaceLeftBottomY = gridHeight - (element.yCoordinate + newHeight);
    if (spaceLeftX < 0 && spaceRightX < 0 || spaceLeftTopY < 0 && spaceLeftBottomY < 0 || calculatedValues.calculatedHeight > gridHeight || calculatedValues.calculatedWidth > gridWidth) {
      return null;
    }
    if (newWidth !== element.width || newHeight !== element.height || newAngleInRadians === 0) {
      const realSnapXPosition = Math.round(
        (spaceRightX < 0 ? gridWidth - newWidth : element.xCoordinate <= 0 ? calculatedValues.widthDifference * -1 : Math.abs(calculatedValues.widthDifference)) / smallUnitSize
      ) * smallUnitSize;
      const realSnapYPosition = Math.round(
        (spaceLeftBottomY < 0 ? gridHeight - newHeight : element.yCoordinate <= 0 ? calculatedValues.heightDifference * -1 : Math.abs(calculatedValues.heightDifference)) / smallUnitSize
      ) * smallUnitSize;
      return {
        rotation: newRotation,
        xCoordinate: spaceLeftX < 0 || spaceRightX < 0 ? realSnapXPosition : element.xCoordinate,
        yCoordinate: spaceLeftTopY < 0 || spaceLeftBottomY < 0 ? realSnapYPosition : element.yCoordinate
      };
    } else {
      return {
        rotation: newRotation
      };
    }
  } else {
    return {
      rotation: newRotation
    };
  }
};

export { calculatePositionOfRotatedElement, getNewPositionWithRotationCore, getWidthAndHeightOfRotatedElement };
